export default __webpack_public_path__ + "6a6db4958b91b5836cc3438225a7be41.svg";